import { createSlice } from '@reduxjs/toolkit';
import { deepCloneArray } from '../global/generalVariables';

export const schedule_vakt = createSlice({
  name: 'schedule_vakt',
  initialState: [],
  reducers: {
    vakterLagret: (state, action) => {
      return action.payload;
    },
    vaktLagtTil: (state, action) => {
      state.push(action.payload);
    },
    vaktEndret: (state, action) => {
      const isSameSchvid = (shift) => shift.id == action.payload.id;
      state[state.findIndex(isSameSchvid)] = action.payload;
    },
    vaktDelt: (state, action) => {
      const isSameSchvid = (shift) => shift.id == action.payload.vakt.id;
      // sletter vakten fra arrayet som viser vakter i vaktuken
      state.splice(state.findIndex(isSameSchvid), 1);
      for (const property in action.payload.nyeVakter) {
        state.push(action.payload.nyeVakter[property].schedule_vakt)
      }
    },
    vaktSlettet: (state, action) => {
      const isSameSchvid = (shift) => shift.id == action.payload.id;
      state.splice(state.findIndex(isSameSchvid), 1);
    },
    vaktUtlyst: (state, action) => {
      const isSameSchvid = (shift) => shift.id == action.payload.vakt.id;
      var tempVakt = deepCloneArray(action.payload.vakt);
      if (tempVakt.utlysing)
        tempVakt.utlysing.push(action.payload.utlysArr);
      else {
        var utl = [];
        utl.push(action.payload.utlysArr);
        tempVakt["utlysing"] = utl;
      }
      state[state.findIndex(isSameSchvid)] = tempVakt;
    },
  },
});

export const { vakterLagret, vaktLagtTil, vaktEndret, vaktDelt, vaktSlettet, vaktUtlyst } = schedule_vakt.actions;
export default schedule_vakt.reducer;